import { Scene } from "@babylonjs/core/scene";
import { Color4 } from "@babylonjs/core/Maths/math.color";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { ArcRotateCamera } from "@babylonjs/core/Cameras/arcRotateCamera";
import { HemisphericLight } from "@babylonjs/core/Lights/hemisphericLight";
import { Vector3D } from "common/types";

export interface CameraOptions {
  alpha?: number;
  beta?: number;
  radius?: number;
  target?: Vector3D;
  lowerBetaLimit?: number;
  upperBetaLimit?: number;
  lowerRadiusLimit?: number;
  upperRadiusLimit?: number;
  attach?: boolean;
}

export interface LightOptions {
  direction?: Vector3D;
  intensity?: number;
}

export interface SceneSetupResult {
  camera: ArcRotateCamera;
  light: HemisphericLight;
}

export const setupGameScene = (
  scene: Scene,
  canvas: HTMLCanvasElement,
  cameraOpts: CameraOptions = {},
  lightOpts: LightOptions = {},
): SceneSetupResult => {
  const cameraConfig = {
    alpha: Math.PI / 4,
    beta: Math.PI / 4,
    radius: 22,
    target: { x: 0, y: 0, z: 0 } as Vector3D,
    attach: true,
    ...cameraOpts,
  };

  const camera = new ArcRotateCamera(
    "camera",
    cameraConfig.alpha,
    cameraConfig.beta,
    cameraConfig.radius,
    new Vector3(cameraConfig.target.x, cameraConfig.target.y, cameraConfig.target.z),
    scene,
  );
  if (cameraConfig.lowerBetaLimit !== undefined) {
    camera.lowerBetaLimit = cameraConfig.lowerBetaLimit;
  }
  if (cameraConfig.upperBetaLimit !== undefined) {
    camera.upperBetaLimit = cameraConfig.upperBetaLimit;
  }
  if (cameraConfig.lowerRadiusLimit !== undefined) {
    camera.lowerRadiusLimit = cameraConfig.lowerRadiusLimit;
  }
  if (cameraConfig.upperRadiusLimit !== undefined) {
    camera.upperRadiusLimit = cameraConfig.upperRadiusLimit;
  }
  if (cameraConfig.attach) {
    camera.attachControl(canvas, true);
  }

  const lightConfig = {
    direction: { x: 0, y: 1, z: 0 } as Vector3D,
    intensity: 1.5,
    ...lightOpts,
  };
  const light = new HemisphericLight(
    "light",
    new Vector3(lightConfig.direction.x, lightConfig.direction.y, lightConfig.direction.z),
    scene,
  );
  light.intensity = lightConfig.intensity;

  scene.clearColor = new Color4(0, 0, 0, 0);

  return { camera, light };
};
